import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default function useOperationSpans({ periodicity, operation }) {
    const { t, i18n } = useTranslation('forecasts');

    const operationSpans = {
        yearly: {
            pointer: [
                {
                    label: t('periodicity.this-year'),
                    id: 0,
                },
                {
                    label: `1 ${t('periodicity.year')}`,
                    id: -1,
                },
                {
                    label: `2 ${t('periodicity.years')}`,
                    id: -2,
                },
            ],
            default: [
                {
                    label: `2 ${t('periodicity.years')}`,
                    id: -2,
                },
                {
                    label: `3 ${t('periodicity.years')}`,
                    id: -3,
                },
                {
                    label: `5 ${t('periodicity.years')}`,
                    id: -5,
                },
            ],
        },
        quarterly: {
            pointer: [
                {
                    label: t('periodicity.this-quarter'),
                    id: 0,
                },
                {
                    label: `1 ${t('periodicity.quarter')}`,
                    id: -1,
                },
                {
                    label: `4 ${t('periodicity.quarters')}`,
                    id: -4,
                },
            ],
            default: [
                {
                    label: `2 ${t('periodicity.quarter')}`,
                    id: -2,
                },
                {
                    label: `4 ${t('periodicity.quarter')}`,
                    id: -4,
                },
                {
                    label: `8 ${t('periodicity.quarter')}`,
                    id: -8,
                },
            ],
        },
        monthly: {
            pointer: [
                {
                    label: t('periodicity.this-month'),
                    id: 0,
                },
                {
                    label: t('periodicity.month-ago'),
                    id: -1,
                },
                {
                    label: t('periodicity.year-ago'),
                    id: -12,
                },
            ],
            default: [
                {
                    label: `3 ${t('periodicity.months')}`,
                    id: -3,
                },
                {
                    label: `6 ${t('periodicity.months')}`,
                    id: -6,
                },
                {
                    label: `12 ${t('periodicity.months')}`,
                    id: -12,
                },
            ],
        },
        weekly: {
            pointer: [
                {
                    label: t('periodicity.this-week'),
                    id: 0,
                },
                {
                    label: `1 ${t('periodicity.week')}`,
                    id: -1,
                },
                {
                    label: `4 ${t('periodicity.weeks')}`,
                    id: -4,
                },
            ],
            default: [
                {
                    label: `1 ${t('periodicity.week')}`,
                    id: -1,
                },
                {
                    label: `2 ${t('periodicity.weeks')}`,
                    id: -2,
                },
                {
                    label: `4 ${t('periodicity.weeks')}`,
                    id: -4,
                },
            ],
        },
        daily: {
            pointer: [
                {
                    label: t('periodicity.today'),
                    id: 0,
                },
                {
                    label: t('periodicity.yesterday'),
                    id: -1,
                },
                {
                    label: t('periodicity.week-ago'),
                    id: -7,
                },
            ],
            default: [
                {
                    label: `2 ${t('periodicity.days')}`,
                    id: -2,
                },
                {
                    label: `7 ${t('periodicity.days')}`,
                    id: -7,
                },
                {
                    label: `14 ${t('periodicity.days')}`,
                    id: -14,
                },
            ],
        },
    };

    return useMemo(() => {
        return operationSpans[periodicity][operation] || operationSpans[periodicity].default;
    }, [operation, periodicity, i18n.language]);
}
